import type { AppStrings } from './types.js';
import { plural } from './plural.js';

export const be: AppStrings = {
  // COMMON
  error_title: 'Памылка',
  cancel: 'Скасаваць',
  retry: 'Паўтарыць',
  back_arrow: '← Назад',

  // ASK SCREEN
  ask_box_unavailable: 'Скрынка недаступна',
  ask_box_unavailable_desc: 'Відаць, спасылка састарэла або аўтар закрыў скрынку.',
  ask_create_own_box: 'Стварыць сваю скрынку',
  ask_sent_title: 'Адпраўлена ✅',
  ask_sent_desc: 'Ананімнае пытанне дайшло да аўтара скрынкі.',
  ask_anonymous_hint: 'Ваша пытанне адправіцца ананімна.',
  ask_placeholder: 'Напішыце пытанне…',
  ask_send: 'Адправіць',
  ask_sending: 'Адпраўка…',
  ask_error_rate_limit: 'Занадта часта, пачакайце хвіліну.',
  ask_error_restart: 'Перазапусціце Mini App.',
  ask_error_load: 'Не ўдалося загрузіць скрынку.',
  ask_error_send: 'Не ўдалося адправіць пытанне.',
  ask_error_banned: 'Вы заблакаваны ў праграме.',
  ask_banned_appeal_btn: 'Аскардзіць',
  ask_appeal_sent: 'Апеляцыя адпраўлена. Мы разгледзім яе ўручную.',

  // AGE GATE
  age_gate_title: 'Толькі для 18+',
  age_gate_desc:
    'Вы адпраўляеце ананімнае пытанне. Будзьце паважлівыя: забаронены здзекі, пагрозы, сексуальны кантэнт у адрас непаўналетніх і любы кантэнт, які парушае закон. Ананімнасць не азначае безакарнасць — парушэнні перадаюцца мадэрацыі. Адпраўляючы пытанне, вы пацвярджаеце, што вам ёсць 18 гадоў, і прымаеце правілы.',
  age_gate_confirm: 'Мне ёсць 18 — працягнуць',

  // INBOX SCREEN
  inbox_title: 'Прыём пытанняў',
  box_link_accordion: 'Спасылка для запрашэнняў',
  inbox_notifications_ask: '🔔 Дазволіць боту дасылаць апавяшчэнні пра новыя пытанні?',
  inbox_notifications_allow: 'Дазволіць',
  inbox_notifications_dismiss_label: 'Схаваць',
  inbox_box_toggle_disable: 'Выключыць прыём',
  inbox_box_toggle_enable: 'Уключыць прыём',
  inbox_box_disabled_warning: 'Прыём пытанняў выключаны — новыя пытанні не прымаюцца.',
  inbox_share_hint: 'Падзяліся спасылкай — сябры змогуць задаць табе ананімныя пытанні.',
  inbox_copy: 'Скапіяваць',
  inbox_copied: 'Скапіявана',
  inbox_copy_error: 'Памылка',
  inbox_no_deeplink: 'Спасылка з`явіцца пасля deploy.',
  inbox_invite_story: 'Запрасіць праз Story',
  inbox_invite_chat: 'Запрасіць праз чат',
  inbox_card_rendering: 'Карточка-запрашэнне яшчэ рэндэрыцца.',
  inbox_story_unsupported:
    'Story недаступны ў гэтай версіі Telegram. Паспрабуй «праз чат».',
  inbox_story_error: 'Не ўдалося адкрыць Story.',
  inbox_chat_unsupported:
    'Шэрынг у чат недаступны ў гэтай версіі Telegram. Абнаві кліент.',
  inbox_chat_error: 'Не ўдалося падзяліцца. Паспрабуй яшчэ раз.',
  inbox_chat_prepare_error: 'Не ўдалося падрыхтаваць запрашэнне.',
  inbox_filter_incoming: 'Уваходныя',
  inbox_filter_hidden: 'Схаваныя',
  inbox_filter_blocked: 'Бан',
  inbox_filter_empty: 'Тут пакуль пуста.',
  inbox_acc_unanswered: 'Без адказу',
  inbox_acc_answered: 'Адказаныя',
  inbox_acc_hidden: 'Схаваныя',
  inbox_acc_blocked: 'Заблакаваныя',
  inbox_empty: 'Пытанняў пакуль няма. Падзяліся спасылкай вышэй.',
  inbox_load_more: 'Загрузіць яшчэ',
  inbox_load_more_error: 'Не ўдалося загрузіць наступную старонку.',
  inbox_error_load: 'Не ўдалося загрузіць скрынку.',
  inbox_rate_limit: 'Занадта часта, пачакайце хвіліну.',
  inbox_toggle_error: 'Не ўдалося змяніць статус скрынкі.',

  // MESSAGE BOX (Трек D)
  message_tagline: 'Напішы мне ананімна',
  message_placeholder: 'Напішыце паведамленне…',
  message_anonymous_hint: 'Ваша паведамленне адправіцца ананімна.',
  message_sent_title: 'Адпраўлена ✅',
  message_sent_desc: 'Ваша ананімнае паведамленне дастаўлена.',
  message_owner_entry: 'Напішы мне',
  message_share_hint: 'Падзяліся спасылкай — і любы зможа даслаць табе ананімнае паведамленне.',
  message_inbox_open: 'Атрыманыя паведамленні',
  message_inbox_title: 'Паведамленні',
  message_inbox_empty: 'Паведамленняў пакуль няма. Падзяліся спасылкай вышэй.',

  // ANSWER SCREEN
  answer_title: 'Адказ на пытанне',
  answer_placeholder: 'Напішыце адказ…',
  answer_submit: 'Адправіць',
  answer_submitting: 'Адпраўка…',
  answer_back: 'Назад',
  answer_error_send: 'Не ўдалося адправіць адказ.',

  // SHARE SCREEN
  share_title: 'Адказ апублікаваны ✅',
  share_hint: 'Падзяліся карточкай і збяры яшчэ больш пытанняў.',
  share_card_rendering_desc:
    'Карточка яшчэ рэндэрыцца. Вярніся да пытанняў і зазірні крыху пазней — зможаш падзяліцца ёй у Story або чаце.',
  share_card_alt: 'Карточка адказу',
  share_story_btn: 'Падзяліцца ў Story',
  share_story_btn_busy: 'Адкрываю…',
  share_chat_btn: 'Падзяліцца ў чат',
  share_chat_btn_busy: 'Рыхтую…',
  share_back: 'Вярнуцца да пытанняў',
  share_story_unsupported:
    'Story недаступны ў гэтай версіі Telegram. Паспрабуй «Падзяліцца ў чат».',
  share_story_error: 'Не ўдалося адкрыць Story. Паспрабуй «Падзяліцца ў чат».',
  share_chat_sent: 'Паведамленне адпраўлена.',
  share_chat_unsupported:
    'Шэрынг у чат недаступны ў гэтай версіі Telegram. Абнаві кліент.',
  share_chat_error: 'Не ўдалося падзяліцца. Паспрабуй яшчэ раз.',
  share_chat_prepare_error: 'Не ўдалося падрыхтаваць паведамленне.',

  // LEADERBOARD SCREEN
  lb_title: 'Лідэрборд',
  lb_period_7d: '7 дзён',
  lb_period_30d: '30 дзён',
  lb_period_all: 'Увесь час',
  lb_group_label: 'Катэгорыя',
  lb_group_all: 'Усе',
  lb_group_ask: 'Пытанні',
  lb_group_rate: 'Ацэнкі',
  lb_group_confession: 'Прызнанні',
  lb_group_guesswho: 'Адгадай хто',
  lb_group_message: 'Паведамленні',
  lb_error: 'Не ўдалося загрузіць лідэрборд',
  lb_empty: 'Пакуль нікога ў рэйтынгу',
  lb_anon: 'Ананім',
  lb_load_more: 'Загрузіць яшчэ',
  lb_questions: (n) => `${n} пыт.`,
  lb_referrals: (n) => `${n} рэф.`,

  // REWARDS SCREEN
  rw_title: 'Мае ўзнагароды',
  rw_error: 'Не ўдалося загрузіць узнагароды',
  rw_level: (n) => `Узровень ${n}`,
  rw_confirmed_referrals: (n) =>
    plural('be', n, {
      one: '{n} пацверджаны рэферал',
      few: '{n} пацверджаных рэфераліх',
      many: '{n} пацверджаных рэфералаў',
      other: '{n} пацверджаных рэфералаў',
    }),
  rw_next_level_section: (n) =>
    plural('be', n, {
      one: 'НАСТУПНЫ ЎЗРОВЕНЬ — {n} рэферал',
      few: 'НАСТУПНЫ ЎЗРОВЕНЬ — {n} рэфералы',
      many: 'НАСТУПНЫ ЎЗРОВЕНЬ — {n} рэфералаў',
      other: 'НАСТУПНЫ ЎЗРОВЕНЬ — {n} рэфералаў',
    }),
  rw_to_level: (level, target) => `да ўзроўню ${level}: ${target}`,
  rw_max_level: 'Максімальны ўзровень дасягнуты!',
  rw_badges_section: 'БЕЙДЖЫ',
  rw_formats_section: 'ФАРМАТЫ СКРЫНКІ',

  // QUESTION CARD
  qcard_status_new: 'Новае',
  qcard_status_hidden: 'Схавана',
  qcard_status_answered: 'Адказана',
  qcard_moderation_flagged: 'Асцярожна, падазронае паведамленне',
  qcard_answer_btn: 'Адказаць',
  qcard_answer_send: 'Адправіць',
  qcard_share_btn: 'Падзяліцца',
  qcard_hide_btn: 'Схаваць',
  qcard_show_btn: 'Паказаць',
  qcard_report_btn: 'Паскардзіцца',
  qcard_block_btn: 'Заблакаваць',
  qcard_unblock_btn: 'Разблакаваць',
  qcard_report_reason_label: 'Выберыце прычыну скаргі:',
  qcard_reason_spam: 'Спам',
  qcard_reason_harassment: 'Здзекі',
  qcard_reason_sexual: 'Сексуальны кантэнт',
  qcard_reason_other: 'Іншае',
  qcard_error_hide: 'Не ўдалося змяніць бачнасць.',
  qcard_error_report: 'Не ўдалося адправіць скаргу.',
  qcard_error_block: 'Не ўдалося заблакаваць адпраўніка.',
  qcard_report_done: 'Скарга адпраўлена — дзякуй.',
  qcard_block_done: 'Адпраўнік заблакаваны.',
  qcard_unblock_done: 'Адпраўнік разблакаваны.',

  // ERRORS
  err_network: 'Няма сувязі з серверам. Праверце інтэрнет і паспрабуйце зноў.',
  err_server_unavailable: 'Сервер часова недаступны, паспрабуйце пазней.',
  err_internal: 'Нешта пайшло не так. Мы ўжо ведаем — паспрабуйце пазней.',
  err_bad_request: 'Праверце ўведзеныя дадзеныя.',
  err_generic: 'Не ўдалося выканаць дзеянне, паспрабуйце пазней.',
  err_schema: 'Памылка дадзеных. Паспрабуйце абнавіць праграму.',
  share_story_link_premium_note:
    'Спасылку ў Story Telegram дае толькі з Telegram Premium. Без яе сябры ўсё роўна знойдуць цябе — нік ёсць на карточцы.',

  // AUTH ERROR SCREEN
  auth_error_title: 'Памылка доступу',
  auth_error_desc:
    'Не ўдалося аўтарызавацца. Калі ласка, зачыніце і зноў адкрыйце Mini App праз Telegram.',

  // REWARD TOAST
  reward_toast_title: 'Новая ўзнагарода!',
  reward_toast_close: '×',

  // BOTTOM TABBAR
  tab_questions: 'Пытанні',
  tab_leaderboard: 'Лідэрборд',
  tab_rewards: 'Узнагароды',
  tab_settings: 'Налады',

  // SETTINGS SCREEN
  settings_title: 'Налады',
  settings_section_general: 'Агульнае',
  settings_notifications: 'Апавяшчэнні пра новыя пытанні',
  settings_notifications_hint: 'Бот будзе дасылаць паведамленне, калі табе зададуць пытанне.',
  settings_notifications_error: 'Не ўдалося захаваць наладу апавяшчэнняў.',
  settings_language: 'Мова',
  settings_language_error: 'Не ўдалося змяніць мову. Паспрабуй яшчэ раз.',
  settings_section_about: 'Пра праграму',
  settings_version: 'Версія',

  // CODE ENTRY (work-020)
  code_modal_title: 'Спасылка ў сторыс — толькі для Premium',
  code_modal_explain:
    'Telegram дае кліктабельную спасылку ў сторыс толькі падпісчыкам Premium. Але вы можаце дадаць у сторыс свой код — гледачы ўвядуць яго ў праграме і зададуць вам ананімнае пытанне.',
  code_modal_your_code: 'Ваш код',
  code_modal_copy: 'Скапіяваць код',
  code_modal_copied: 'Скапіявана',
  code_modal_share_btn: 'Падзяліцца ў сторыс',
  code_modal_loading: 'Рыхтуем код…',
  code_modal_error: 'Не ўдалося атрымаць код. Паспрабуйце пазней.',
  ask_code_title: 'Увядзіце код',
  ask_code_desc:
    'Калі вы перайшлі са сторыс — знайдзіце ў ёй код (напрыклад, 1234) і ўвядзіце ніжэй.',
  ask_code_placeholder: 'Код са сторыс',
  ask_code_find: 'Знайсці',
  ask_code_not_found: 'Код не знойдзены. Праверце лічбы і паспрабуйце зноў.',
  ask_code_invalid: 'Код складаецца з 4 лічбаў.',
  code_onboarding_header: 'Прыйшлі са сторыс?',
  code_onboarding_text: 'Увядзіце код сябра, каб задаць яму ананімнае пытанне.',
  code_onboarding_action: 'Увесці код',
  settings_ask_by_code: 'Спытаць па кодзе',
  settings_my_code_title: 'Ваш код для сторыс',
  settings_my_code_hint:
    'Напішыце гэты код у сторыс — гледачы ўвядуць яго, каб задаць вам ананімнае пытанне. Кліктабельную спасылку ў сторыс Telegram дае толькі Premium-падпісчыкам.',
  settings_my_code_rotate: 'Атрымаць новы код',
  settings_my_code_rotating: 'Мяняем…',
  settings_my_code_done: 'Код абноўлены',
  settings_my_code_error: 'Не ўдалося атрымаць код.',
  settings_my_code_rotate_confirm_title: 'Памяняць код?',
  settings_my_code_rotate_confirm_desc:
    'Стары код перастане працаваць адразу. Усе, хто бачыў яго ў вашай сторыс, ужо не змогуць вам напісаць. Мяняйце, толькі калі вам хтосьці спаміць.',
  settings_my_code_rotate_confirm_action: 'Памяняць код',

  // BOT
  bot_greeting: (name) => (name ? `Прывітанне, ${name}! 👋` : 'Прывітанне! 👋'),
  bot_onboarding:
    'Гэта VeylMe — ананімныя пытанні.\n\n' +
    'Адкрый mini app, апублікуй картку «Задай мне ананімнае пытанне» ў сваю Story — ' +
    'і атрымлівай ананімныя пытанні прама сюды.\n\n' +
    '⚠️ 18+. Будзь паважлівы: травля, пагрозы і забаронены кантэнт ' +
    'недапушчальны. Ананімнасць ≠ безакарнасць — парушэнні перадаюцца мадэрацыі.',
  bot_open_btn: 'Адкрыць VeylMe',
  notify_answer_btn: 'Адказаць',
  bot_invite_text:
    'Нехта падзяліўся спасылкай на VeylMe.\n\n' +
    'Адкрый mini app, каб задаць ананімнае пытанне:',
  bot_invite_btn: 'Спытаць ананімна',

  // WORK-027 i18n sweep
  tagline: 'Задай мне ананімнае пытанне',
  share_ask_action: 'Спытаць',
  share_answered_text: 'Я адказаў на ананімнае пытанне 👀',
  err_not_in_telegram: 'Mini App не запушчана ў Telegram. Перазапусціце праграму.',
  badge_viral_starter: 'Віруснае адкрыццё',
  badge_storyteller: 'Апавядальнік',
  badge_loop_master: 'Майстар цыклу',
  theme_confession: 'Прызнанні',
  theme_guesswho: 'Адгадай хто',
  rw_format_named: (name) => `фармат «${name}»`,
  card_label_question: 'Пытанне',
  card_label_answer: 'Адказ',
  card_invite_subtitle: 'ананімна, без аўтарызацыі',
  card_code_hint: 'УВЯДЗІ КОД У ПРАГРАМЕ',
  share_msg_title: (brand) => `${brand} · Ананімныя пытанні`,
  notify_new_question: '🔔 Вам задалі ананімнае пытанне',
  notify_unanswered_reminder: (n) =>
    plural('be', n, {
      one: '🔔 У вас {n} неадказанае пытанне',
      few: '🔔 У вас {n} неадказаных пытанні',
      many: '🔔 У вас {n} неадказаных пытанняў',
      other: '🔔 У вас {n} неадказаных пытанняў',
    }),
  notify_ban_permanent: 'назаўсёды',
  notify_ban_until: (date) => `да ${date}`,
  notify_ban_msg: (untilPhrase) =>
    `⛔ Вы заблакаваны ў VeylMe ${untilPhrase}. Занадта шмат атрымальнікаў паскардзіліся на вашы паведамленні.\nКалі лічыце гэта памылкай — падайце апеляцыю ў праграме.`,
  notify_warning_msg:
    '⚠️ Некалькі атрымальнікаў паскардзіліся на вашы паведамленні. Яшчэ трохі — і вы будзеце заблакаваны ў VeylMe.',

  // MY QUESTIONS SCREEN + InvitePanel non-premium hint (retention-answer-loop)
  my_questions_title: 'Мае пытанні',
  my_questions_empty_title: 'Ты яшчэ не задаваў пытанняў',
  my_questions_empty_desc: 'Задай пытанне ў чыйсьці скрыню — адказ зʼявіцца тут.',
  my_questions_loading: 'Правяраем, ці ёсць адказ…',
  my_questions_waiting: 'Чакае адказу',
  my_questions_answer_label: 'Адказ',
  settings_my_questions: 'Мае пытанні',
  ask_sent_find_reply_hint: 'Адказ можна будзе знайсці пазней у «Маіх пытаннях».',
  inbox_story_nonpremium_hint: 'Спасылка ў Story не клікабельная без Telegram Premium, таму паказваем код — дасланне ў чат надзейнейшае.',

  // SESSION EXPIRY SCREEN (work-038)
  session_expired_title: 'Пропуск Telegram састарэў',
  session_expired_desc: 'Telegram выдае праграме пропуск адзін раз пры запуску, і гэты ўжо састарэў. Адкрыйце праграму нанова — пачаты тэкст мы захавалі.',
  session_expired_desc_no_storage: 'Пропуск Telegram састарэў, праграму трэба адкрыць нанова. Захаваць уведзены тэкст не ўдалося — скапіруйце яго перад выхадам.',
  session_expired_reopen: 'Адкрыць нанова',
  session_expired_stuck_title: 'Telegram выдаў той самы стары пропуск',
  session_expired_stuck_desc: 'Закрыйце праграму цалкам праз меню бота і адкрыйце зноў — тады Telegram выдасць новы пропуск.',
  session_auth_failed_title: 'Не ўдалося пацвердзіць уваход',
  session_auth_failed_desc: 'Telegram не пацвердзіў уваход у праграму. Закрыйце праграму і адкрыйце яе нанова з чата з ботам.',
  session_expired_manual_close: 'Закрыць праграму адсюль не атрымаецца — закрыйце яе самі і адкрыйце нанова з чата з ботам.',
  session_expiring_soon: 'Пропуск Telegram хутка скончыцца. Адкрыйце праграму нанова, каб нічога не страціць.',
  my_questions_check_failed: 'Не ўдалося праверыць адказы. Паспрабуйце пазней.',
  settings_notifications_load_error: 'Не ўдалося загрузіць наладу.',
};
